import { twMerge } from 'tailwind-merge'

type ContainerProps = {
  children: React.ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
} & React.ComponentPropsWithoutRef<'div'>

const sizeStyles = {
  sm: 'max-w-lg',
  md: 'max-w-3xl',
  lg: 'max-w-5xl',
  xl: 'max-w-(--breakpoint-xl)',
  '2xl': 'max-w-(--breakpoint-2xl)',
  '3xl': 'max-w-[120rem]',
}

export default function Container({ className, size, children }: ContainerProps) {
  className = twMerge('mx-auto relative', sizeStyles[size || 'lg'], className)

  return <div className={className}>{children}</div>
}
